import React from 'react';

const Spacer = ({ size }) => {
  return <div style={{ width: `${size}px`, height: `${size}px` }} />;
};

export default Spacer;
